export default {
  data() {
    return {
      submitMethod: null,
      entityChanged: false,
      options: {
        okText: 'Submit and leave',
        cancelText: 'Leave without submitting',
        // backdropClose: true,
      },
      message: {
        title: 'Hold on!',
        body: 'You are leaving edit modal without submitting your changes.',
      },
    };
  },
  methods: {
    initBeforeLeave(changed, method) {
      this.entityChanged = changed;
      this.submitMethod = method;
    },
    setUnchanged() {
      this.entityChanged = false;
    },
    beforeModalClose(event, close) {
      if (this.interval) clearInterval(this.interval);
      if (this.entityChanged) {
        event.preventDefault();
        this.$dialog
          .confirm(this.message, this.options)
          .then(() => {
            this.submitMethod(close);
          })
          .catch(() => {
            close();
          });
      }
    },
  },
};
